module.exports = __webpack_public_path__ + "media/images/invite_confirm-d0d965a0.svg";